// Use this object to reserve query-params
export const RESERVED_QUERY_PARAMS = {
  // it must be used in a public streamer page to work
  GIFT_PACK_COUPON_CODE: 'couponCode',
  // it does not require a public streamer page but it will be checked in the next checkout
  PACKS_DISCOUNT_CODE: 'packsDiscountCode',
  // Only while a ticket campaign active
  EXTRA_TICKET_CODE: 'extraTicketCode',
};
